import { render } from "./projects.vue?vue&type=template&id=4f27e274&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"

import "./projects.vue?vue&type=style&index=0&id=4f27e274&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f27e274"]])

export default __exports__